var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cxs from 'cxs/component';
import Theme from 'Theme';
var BackgroundImage = /** @class */ (function (_super) {
    __extends(BackgroundImage, _super);
    function BackgroundImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundImage.prototype.render = function () {
        var _a = this.props, _image = _a.image, children = _a.children, props = __rest(_a, ["image", "children"]);
        var image = typeof _image === 'string'
            ? _image
                ? _image.indexOf('base64') >= 0
                    ? _image
                    : _image.includes('http') ? _image : process.env.REACT_APP_SERVER + _image
                : require('images/placeholder.png')
            : typeof _image === 'object' && _image instanceof ArrayBuffer ? _image
                : require('images/placeholder.png');
        return (React.createElement(Wrapper, __assign({}, props),
            React.createElement(Image, { image: image }, children)));
    };
    return BackgroundImage;
}(Component));
export default BackgroundImage;
var Wrapper = cxs('div')({
    position: 'relative',
    margin: '0 auto',
    // padding: Theme.size.space[2],
    overflow: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    outline: '1px solid #eee'
});
var Image = cxs('div')(function (_a) {
    var image = _a.image;
    return ({
        backgroundImage: image
            ? "url(".concat(image, ")")
            : "url(".concat(require('images/placeholder.png'), ")"),
        width: '100%',
        paddingBottom: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain'
    });
});
Image.propTypes = {
    image: PropTypes.string
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/BackgroundImage.tsx
// module id = 946
// module chunks = 0